// extracted by mini-css-extract-plugin
export default {"container":"filter-item_container__vcnHQ","label":"filter-item_label__y6hnn","cost-range":"filter-item_cost-range__VDlG+","cost-input":"filter-item_cost-input__-oAkF"};